module.exports = __webpack_public_path__ + "kusamaproject/img/watermark.ebe5fe86.png";